var render, staticRenderFns
import script from "./AssistanceChart.vue?vue&type=script&lang=js&"
export * from "./AssistanceChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('78a3e837', component.options)
    } else {
      api.reload('78a3e837', component.options)
    }
    
  }
}
component.options.__file = "src/components/student-profile/components/home/AssistanceChart.vue"
export default component.exports